<div style="overflow-y: auto; height: calc(100vh - 112px);">
  <div class="container-fluid">
    <div style="overflow-x: hidden;">
      <div class="row justify-content-center pt-4">
        <div class="col-12 col-md-11">
          <span class="rm-title rm-title-3">User Settings</span><br/><br/>
          <!-- <span class="rm-title rm-title-6">
            Update user settings, 2 Factor Authentication (2FA), and reset password from this page
          </span> -->
        </div>
      </div>
      <div class="row justify-content-center pt-3">
        <div class="col-12 col-md-11">
          <div class="row">
            <app-user-card [firstName]="userForm.get('firstName')?.value || undefined"
                           [lastName]="userForm.get('lastName')?.value || undefined"
                           [displayName]="userForm.get('email')?.value || undefined"
                           [borderColor]="'transparent'"
                           [background]="'#F1EDE4'"
                           [sideColor]="'#002150'"
                           [size]="userCardSize.LG"
                           [image]="userForm.get('imageUrl')?.value || undefined"
            ></app-user-card>
          </div>
          <br/>
          <div class="row justify-content-center">
            <div class="col-12 text-start">
              <button type="button" color="primary" mat-raised-button (click)="openImageUploadModal()">Upload User Profile Image</button>&nbsp;
              <button type="button" color="warn" mat-raised-button (click)="clearImage()">Clear User Image</button>
            </div>
          </div>
        </div>
      </div>
      <!--    WELL START-->
      <div class="row justify-content-center pt-5">
        <div class="col-12 col-md-11">
          <form [formGroup]="userForm" (ngSubmit)="saveUserInfo()">
            <div class="row">
              <span style="font-size: large; font-weight: bold;">User Information</span>
              <em class="text-muted">Update your personal information</em>
            </div>
            <br/>
            <div class="row">
              <div class="col-12 col-md-4">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>First Name</mat-label>
                  <input class="form-input" matInput formControlName="firstName" placeholder="i.e. John"/>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input class="form-input" matInput formControlName="lastName" placeholder="i.e. Smith"/>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-8">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input class="form-input" matInput formControlName="email" placeholder="i.e. example@rondeivu.com"/>
                  <span matSuffix class="green" *ngIf="userSettings.emailVerified" title="Email is verified"><mat-icon>check</mat-icon></span>
                  <mat-hint align="end">To change your email address please contact Rondeivu at info&#64;rondeivu.com</mat-hint>
                </mat-form-field>
              </div>
            </div>
            <!--          row start-->
            <div class="row" style="padding-top: 20px;">
              <div class="col-12 text-end">
                <button type="submit" mat-raised-button color="primary">Save Changes</button>
              </div>
            </div>
            <!--          rows end-->
          </form>
        </div>
      </div>
      <br/><br/>
      <!--    WELL START-->
      <div class="row justify-content-center" [hidden]="environment.rondeivu_env_title === 'DEMO'">
        <div class="col-12 col-md-11">
          <hr/>
          <br/>
          <form [formGroup]="phoneForm" (ngSubmit)="verifyPhone()">
            <div class="row">
              <span style="font-size: large; font-weight: bold;">Verify Phone Number for 2 Factor Authentication</span><br />
              <em class="text-muted">Multi-factor authentication is very important step toward protecting you and your company's sensitive data</em>
            </div>
            <br/>
            <div class="row">
              <div class="col-12 col-md-4">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Country Code</mat-label>
                  <mat-select id="cc" formControlName="countryCode">
                    <mat-option *ngFor="let cc of lookupService.lookups.countryCodes" [value]="cc.key">
                      {{ cc.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-8">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Phone Number</mat-label>
                  <input class="form-input" matInput formControlName="mobile" placeholder="555-555-5555"/>
                  <mat-icon matSuffix class="green" *ngIf="userForm.get('phoneNumberVerified')?.value" title="Phone number is verified">check</mat-icon>
                </mat-form-field>
              </div>

              <div class="col-12">
                <div class="row" *ngIf="!userForm.get('phoneNumberVerified')?.value">
                  <div class="col-12 text-center">
                    <div class="notify">
                      <mat-icon id="notify-icon">warning</mat-icon>
                      <span style="line-height: 24px;height:24px;">Your phone number requires verification</span>&nbsp;
                    </div>
                  </div>
                </div>

                <!-- <div class="col-12 text-center" *ngIf="userForm.get('phoneNumberVerified')?.value">
                  <div class="notify-good ">
                    <span style="font-size: 0.88rem;">Your phone number is verified</span>&nbsp;
                    <mat-icon id="notify-good-icon">done</mat-icon>
                  </div>
                </div> -->
              </div>
            </div>

            <div class="row pt-4">
              <div class="col-12 text-end">
                <button type="submit" mat-raised-button color="primary">Save Phone Number & Enable 2 Factor Authentication</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <br/><br/>
      <!--WELL START-->
      <div class="row justify-content-center pb-5">
        <div class="col-12 col-md-11">
          <hr/>
          <form [formGroup]="changePasswordFormGroup" class="pt-4" (ngSubmit)="changePassword()">
            <!-- This hidden input prevents the autofill of the password fields. -->
            <input autocomplete="false" name="hidden" type="text" hidden>
            <div class="row">
              <span style="font-size: large; font-weight: bold;">Change Your User Password</span>
              <em class="text-muted">Ensure your account is using a long and complex password to stay secure</em>
            </div>
            <br/>
            <!--          row start-->
            <div class="row">
              <div class="col-12 col-md-6">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Old Password</mat-label>
                  <input class="form-input" matInput formControlName="oldPassword" autocomplete="new-password"
                         aria-autocomplete="none" [type]="showPassword ? 'text' : 'password'"/>
                  <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword"
                          [attr.aria-label]="'Hide or show password'" [attr.aria-pressed]="showPassword">
                  <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>

                  <mat-error *ngIf="changePasswordFormGroup.get('oldPassword')?.hasError('required')">
                    Password is required.
                  </mat-error>
                  <mat-hint align="end">This is your old password</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>New Password</mat-label>
                  <input class="form-input" matInput formControlName="newPassword" autocomplete="new-password"
                         aria-autocomplete="none" [type]="showPassword ? 'text' : 'password'"/>
                  <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword"
                          [attr.aria-label]="'Hide or show password'" [attr.aria-pressed]="showPassword">
                    <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                  
                  <mat-error *ngIf="changePasswordFormGroup.get('newPassword')?.hasError('required')">
                    Password is required.
                  </mat-error>
                  <mat-error *ngIf="changePasswordFormGroup.get('newPassword')?.hasError('pattern')">
                    Password must be a combination of lower-case, upper-case, numbers, special characters, and at least 8 characters long.
                  </mat-error>
                  <mat-hint align="end">This is your NEW password</mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="row pt-4">
              <div class="col-12 text-end">
                <button type="submit" mat-raised-button color="primary"
                        [disabled]="changePasswordFormGroup.invalid">
                  Update Password
                </button>
              </div>
            </div>
            <!--          rows end-->
          </form>
        </div>
      </div>
      <!--      WELL END-->
    </div>
  </div>
</div>

